import Promise from 'bluebird';
import $ from 'jquery';
import './block-ad-block';
import type { IsAdBlockOnOptions } from './types';

const { blockAdBlock } = window;

// ConnectivityCheck/CanConnect always fails for proxy, so disable check
const isProxy = window.location.port === '12000';

export const isAdBlockOn = ({
  CampaignUIAPI = '/Campaign/',
  logMessage,
}: IsAdBlockOnOptions = {}) => {
  // Sometimes window.blockAdBlock will be removed by some adblockers
  if (!blockAdBlock || blockAdBlock.getAdBlockOn(logMessage)) {
    return Promise.resolve(true);
  }

  if (!isProxy) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: `${CampaignUIAPI}API/ConnectivityCheck/CanConnect?Advertiser=1&Ad=1&BannerAd=1`,
        success: data => resolve(data !== 'OK'),
        type: 'GET',
        error: reject,
      });
    }).catch(() => {
      if (logMessage) {
        // found ad blocker
        logMessage('blockAdBlock');
      }
      return true;
    });
  }

  return Promise.resolve(false);
};

